import React from 'react';
import useSort, { SortType } from './useSort';
import './Table.css'
import { useIntl } from 'react-intl';

const classNames = require('classnames');
export interface ITableSet {
    titleId: string,
    key?: string,
    handleSort?: (a: any, b: any) => number,
    cover?: (rowIndex: number, rowData?: any) => JSX.Element,
    class?: string,
    style?: React.CSSProperties,
}

export interface ILineSet {
    style?: React.CSSProperties
    className?: string
}

function TRow(props: {
    tableSets: ITableSet[],
    data: any
    rowIndex: number
}) {
    function item(index: number) {
        let tableSet = props.tableSets[index];
        if (tableSet.cover) {
            return tableSet.cover(props.rowIndex, props.data);
        } else if (tableSet.key) {
            return props.data[tableSet.key];
        } else {
            return ""
        }
    }

    let chart = [];
    for (let i = 0; i < props.tableSets.length; i++) {
        chart.push(
            <td key={i} className="text-nowrap text-truncate" title={typeof item(i) === "string" ? item(i) : ""}>
                <span style={{fontSize: 15}}>{item(i)}</span>
            </td>
        )
    }
    return (<>
        {chart}
    </>
    )
}

function TBody(props: {
    tableSets: ITableSet[],
    lineSets?: (rowIndex: number, rowData?: any) => ILineSet
    data: Array<any>
}) {
    let chart = [];
    for (let i = 0; i < props.data.length; i++) {
        const lineSet = props.lineSets ? props.lineSets(i, props.data[i]) : {};
        chart.push(
            <tbody key={i}>
                <tr className={classNames(lineSet.className ? lineSet.className : undefined)} style={lineSet.style ? lineSet.style : undefined}>
                    <TRow tableSets={props.tableSets} data={props.data[i]} rowIndex={i} />
                </tr>
            </tbody>
        )
    }
    return (<>{chart}</>)

}

function THItem(props: {
    title: string,
    type: SortType,
    onclick: () => void,
    sortEnable: boolean,
    class?: string,
    style?: React.CSSProperties,
}) {
    function sortShow() {
        switch (props.type) {
            case SortType.NONE:
                return "";
            case SortType.OBVERSE:
                return " ↑";
            case SortType.REVERSE:
                return " ↓";
            default:
                return "";
        }
    }
    const { formatMessage } = useIntl();

    const title = formatMessage({ id: props.title, defaultMessage: props.title, description: props.title })

    return (
        <th
            onClick={props.onclick}
            style={Object.assign({ cursor: props.sortEnable ? "pointer" : "default" }, props.style)}
            className={classNames("text-nowrap", "text-truncate", props.class)}
            title={title}
        
        >
            <span style={{fontSize: 15}}>{title}</span>
            {/* {props.title} */}
            {sortShow()}
        </th>
    )
}

function THeader(props: {
    tableSets: ITableSet[],
    getType: (key?: string) => SortType,
    handleSort: (key?: string) => void
}) {
    let chart = [];
    for (let i = 0; i < props.tableSets.length; i++) {
        chart.push(
            <THItem
                key={i}
                type={props.getType(props.tableSets[i].key)}
                onclick={() => {
                    props.handleSort(props.tableSets[i].key);
                }}
                title={props.tableSets[i].titleId}
                sortEnable={props.tableSets[i].handleSort ? true : false}
                class={props.tableSets[i].class}
                style={props.tableSets[i].style}
            />
        )
    }
    return (
        <tbody>
            <tr>
                {chart}
            </tr>
        </tbody>
    )
}

function Table(props: {
    tableSets: ITableSet[],
    data: any[],
    className?: string,
    lineSets?: (rowIndex: number, rowData?: any) => ILineSet
}) {
    const [dataShow, getType, handleSort] = useSort(props.data, props.tableSets);

    return (
        <table className={classNames("table gsde", props.className)}>
            <THeader tableSets={props.tableSets} getType={getType} handleSort={handleSort} />
            <TBody lineSets={props.lineSets} tableSets={props.tableSets} data={dataShow} />
        </table>
    )
}

export default Table;